import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronDown } from '@fortawesome/pro-solid-svg-icons/faChevronDown'

import styles from './dropdownIndicator.module.scss'

const DropdownIndicator = () => {
    return <FontAwesomeIcon className={styles.icon} icon={faChevronDown} />
}

export default DropdownIndicator
